// export const genioAIFlow = {
//   intro: {
//     voiceBefore: 'Welcome to Genio AI Article Mining.',
//   },
//   domains: {
//     voiceBefore: 'Please select Genio AI Data Sources.',
//     voiceAfter: 'Great!',
//   },
//   date: {
//     voiceBefore: 'Set the date for Genio AI to activate data mining.',
//     // voiceAfter: 'Well done!',
//   },
//   specialty: {
//     voiceBefore:
//       'Well done!...............     Select your AI specialization field.',
//     voiceAfter: "Nice! Let's go deeper with the sub-specialty.",
//   },
//   subSpecialty: {
//     voiceBefore: 'Choose the AI sub-specialty.',
//     voiceAfter: 'Perfect! Now define the type of study.',
//   },
//   typeOfStudy: {
//     voiceBefore: 'What type of study are you analyzing?',
//     voiceAfter: 'Excellent! Finally, input your custom query text.',
//   },
//   finish: {
//     voiceBefore:
//       'Genio AI is now in action!\n\nYour data mining process has been initiated.\n\nSit back and let the intelligence unfold as Genio AI dives deep to extract insights and deliver precision results!',
//   },
// };
export const genioAIFlow = {
  intro: require('../audio/welcome.mp3'),
  domainsBefore: require('../audio/please.mp3'),
  domainsAfter: require('../audio/great.mp3'),
  dateBefore: require('../audio/set.mp3'),
  specialtyBefore: require('../audio/wellDone.mp3'),
  specialtyAfter: require('../audio/nice.mp3'),
  subSpecialtyBefore: require('../audio/choose.mp3'),
  subSpecialtyAfter: require('../audio/perfect.mp3'),
  finish: require('../audio/finish.mp3'),
};

export const genioAIFormFields = [
  'domains',
  'date',
  'specialty',
  'subSpecialty',
];

export const flowKeys = Object.keys(genioAIFlow);

// Get the next field based on the form's progress
export const getNextField = (
  currentField: keyof typeof genioAIFlow,
): keyof typeof genioAIFlow | null => {
  const currentIndex = flowKeys.indexOf(currentField);
  if (currentIndex === -1 || currentIndex === flowKeys.length - 1) {
    return null;
  }
  return flowKeys[currentIndex + 1] as keyof typeof genioAIFlow;
};

// Get the prev field based on the form's progress
export const getPrevField = (
  currentField: keyof typeof genioAIFlow,
): keyof typeof genioAIFlow | null => {
  const currentIndex = flowKeys.indexOf(currentField);
  if (currentIndex === -2 || currentIndex === flowKeys.length - 2) {
    return null;
  }
  return flowKeys[currentIndex - 1] as keyof typeof genioAIFlow;
};

export const getNextFieldIndex = (
  currentField: keyof typeof genioAIFlow,
): number | null => {
  const currentIndex = flowKeys.indexOf(currentField);
  if (currentIndex === -1 || currentIndex === flowKeys.length - 1) {
    return null;
  }
  return currentIndex + 1;
};

export const getFieldIndex = (
  currentField: keyof typeof genioAIFlow,
): number | null => {
  const currentIndex = flowKeys.indexOf(currentField);
  if (currentIndex === -1 || currentIndex === flowKeys.length - 1) {
    return null;
  }
  return currentIndex;
};

///////////// Research //////////////
export const genioResearchFormFields = ['domains', 'date', 'text'];

export const genioResearchFlow = {
  intro: require('../audio/welcome.mp3'),
  domainsBefore: require('../audio/please.mp3'),
  domainsAfter: require('../audio/great.mp3'),
  dateBefore: require('../audio/set.mp3'),
  specialtyBefore: require('../audio/excellent.mp3'),
  // specialtyAfter: require('../audio/nice.mp3'),
  // subSpecialtyBefore: require('../audio/choose.mp3'),
  // subSpecialtyAfter: require('../audio/perfectTypeOfStudy.mp3'),
  // typeOfStudyBefore: require('../audio/what.mp3'),
  // typeOfStudyAfter: require('../audio/excellent.mp3'),
  finish: require('../audio/finish.mp3'),
};
export const flowResearchKeys = Object.keys(genioResearchFlow);

// Get the next field based on the form's progress
export const getNextResearchField = (
  currentField: keyof typeof genioResearchFlow,
): keyof typeof genioResearchFlow | null => {
  const currentIndex = flowResearchKeys.indexOf(currentField);
  if (currentIndex === -1 || currentIndex === flowResearchKeys.length - 1) {
    return null;
  }
  return flowResearchKeys[currentIndex + 1] as keyof typeof genioResearchFlow;
};

// Get the prev field based on the form's progress
export const getPrevResearchField = (
  currentField: keyof typeof genioResearchFlow,
): keyof typeof genioResearchFlow | null => {
  const currentIndex = flowResearchKeys.indexOf(currentField);
  if (currentIndex === -2 || currentIndex === flowResearchKeys.length - 2) {
    return null;
  }
  return flowResearchKeys[currentIndex - 1] as keyof typeof genioResearchFlow;
};

export const getNextResearchFieldIndex = (
  currentField: keyof typeof genioResearchFlow,
): number | null => {
  const currentIndex = flowResearchKeys.indexOf(currentField);
  if (currentIndex === -1 || currentIndex === flowResearchKeys.length - 1) {
    return null;
  }
  return currentIndex + 1;
};

export const getFieldResearchIndex = (
  currentField: keyof typeof genioResearchFlow,
): number | null => {
  const currentIndex = flowResearchKeys.indexOf(currentField);
  if (currentIndex === -1 || currentIndex === flowResearchKeys.length - 1) {
    return null;
  }
  return currentIndex;
};
